import { render } from "./DefaultLayouts.vue?vue&type=template&id=77a1abee&scoped=true"
import script from "./DefaultLayouts.vue?vue&type=script&lang=js"
export * from "./DefaultLayouts.vue?vue&type=script&lang=js"

import "./DefaultLayouts.vue?vue&type=style&index=0&id=77a1abee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a1abee"]])

export default __exports__